/* ============================================
   PINK MAHOGHANY — THEME JAVASCRIPT
   Bold Sensory Design System
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* =============================================
     HEADER SCROLL (transparent mode only)
  ============================================= */
  const header = document.getElementById('site-header');
  if (header) {
    const isTransparent = header.getAttribute('data-transparent') === 'true';
    if (isTransparent) {
      const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* =============================================
     MOBILE NAV TOGGLE
  ============================================= */
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('active');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    // Close menu when a sublink is clicked
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMobileMenu));

    // Mobile nav group accordion
    mobileMenu.querySelectorAll('.mobile-nav-group-toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.mobile-nav-group');
        const isOpen = group.classList.contains('open');
        // Close all other groups
        mobileMenu.querySelectorAll('.mobile-nav-group').forEach(g => g.classList.remove('open'));
        if (!isOpen) group.classList.add('open');
      });
    });
  }

  /* =============================================
     DESKTOP DROPDOWN — keyboard / click support
  ============================================= */
  document.querySelectorAll('.nav-group-toggle').forEach(toggle => {
    // Open on click (touch devices)
    toggle.addEventListener('click', (e) => {
      const group = toggle.closest('.nav-group');
      const dropdown = group.querySelector('.nav-dropdown');
      const isOpen = dropdown.classList.contains('open');
      // Close all
      document.querySelectorAll('.nav-dropdown').forEach(d => {
        d.classList.remove('open');
        d.closest('.nav-group').querySelector('.nav-group-toggle').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        dropdown.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-group')) {
      document.querySelectorAll('.nav-dropdown').forEach(d => {
        d.classList.remove('open');
        d.closest('.nav-group').querySelector('.nav-group-toggle').setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* =============================================
     CART DRAWER
  ============================================= */
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('active'); overlay.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('active'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  // Close on overlay click
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  // Close button inside drawer
  document.addEventListener('click', (e) => {
    if (e.target.closest('#cart-drawer-close')) closeCartDrawer();
  });

  // Cart icon in header opens drawer (not navigate)
  const headerCartLink = document.querySelector('.nav-links a[href="/cart"]');
  if (headerCartLink) {
    headerCartLink.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Cart icon in mobile menu
  const mobileCartLink = document.querySelector('.mobile-menu-cart-link');
  if (mobileCartLink) {
    mobileCartLink.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileMenu();
      setTimeout(openCartDrawer, 200);
    });
  }

  /* =============================================
     CART DRAWER — AJAX RENDER
  ============================================= */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function renderDrawer() {
    try {
      const cart = await fetchCart();

      // Update count badge
      document.querySelectorAll('.nav-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });

      // Update drawer count label
      const countEl = document.getElementById('drawer-item-count');
      if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');

      // Update shipping bar
      const threshold = 7500; // $75 in cents
      const progress = Math.min(100, Math.round(cart.total_price / threshold * 100));
      const shippingFill = document.getElementById('drawer-shipping-fill');
      const shippingText = document.getElementById('drawer-shipping-text');
      if (shippingFill) shippingFill.style.width = progress + '%';
      if (shippingText) {
        if (cart.total_price >= threshold) {
          shippingText.innerHTML = '<span class="shipping-unlocked">&#10003; You\'ve unlocked free shipping!</span>';
        } else {
          const remaining = threshold - cart.total_price;
          shippingText.innerHTML = 'Spend <strong>' + formatMoney(remaining) + '</strong> more for free shipping';
        }
      }

      // Render items
      const itemsEl = document.getElementById('cart-drawer-items');
      const footerEl = document.getElementById('cart-drawer-footer');

      if (cart.item_count === 0) {
        if (itemsEl) itemsEl.innerHTML = `
          <div class="cart-drawer-empty">
            <div class="cart-drawer-empty-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
            </div>
            <p class="cart-drawer-empty-title">Your cart is empty</p>
            <p class="cart-drawer-empty-body">Discover your signature scent</p>
            <a href="/collections/fragrances" class="btn btn-primary cart-drawer-shop-btn">Shop the Collection</a>
          </div>`;
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (footerEl) footerEl.style.display = '';

      // Update subtotal
      const subtotalEl = document.getElementById('drawer-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      // Render items list
      if (itemsEl) {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-drawer-item" data-key="${item.key}">
            <a href="${item.url}" class="cart-drawer-item-img-link">
              <div class="cart-drawer-item-img">
                ${item.image
                  ? `<img src="${item.image.replace(/\.(jpg|jpeg|png|webp|gif)/, '_200x.$1')}" alt="${item.title}" loading="lazy" width="100" height="125">`
                  : '<div class="cart-drawer-item-img-placeholder">PM</div>'
                }
              </div>
            </a>
            <div class="cart-drawer-item-info">
              <a href="${item.url}" class="cart-drawer-item-name">${item.product_title}</a>
              ${item.variant_title && item.variant_title !== 'Default Title'
                ? `<span class="cart-drawer-item-variant">${item.variant_title}</span>`
                : ''
              }
              <div class="cart-drawer-item-bottom">
                <div class="cart-drawer-qty" data-key="${item.key}">
                  <button type="button" class="cart-drawer-qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">&#8722;</button>
                  <span class="cart-drawer-qty-num">${item.quantity}</span>
                  <button type="button" class="cart-drawer-qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
                </div>
                <span class="cart-drawer-item-price">${formatMoney(item.line_price)}</span>
              </div>
              <button type="button" class="cart-drawer-remove" data-key="${item.key}" aria-label="Remove ${item.title}">Remove</button>
            </div>
          </div>
        `).join('');
      }

    } catch (err) {
      console.error('Cart render error:', err);
    }
  }

  // Qty and remove buttons (delegated)
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.cart-drawer-qty-btn');
    const removeBtn = e.target.closest('.cart-drawer-remove');

    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const action = qtyBtn.dataset.action;
      const qtyEl = qtyBtn.closest('.cart-drawer-qty')?.querySelector('.cart-drawer-qty-num');
      const currentQty = parseInt(qtyEl?.textContent || '1');
      const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        await renderDrawer();
      } catch (err) { console.error(err); }
    }

    if (removeBtn) {
      const key = removeBtn.dataset.key;
      const item = removeBtn.closest('.cart-drawer-item');
      if (item) { item.style.opacity = '0.4'; item.style.pointerEvents = 'none'; }
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        await renderDrawer();
      } catch (err) { console.error(err); }
    }
  });

  /* =============================================
     ADD TO CART — AJAX + OPEN DRAWER
  ============================================= */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn') || form.querySelector('button[type="submit"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      const originalHTML = btn?.innerHTML;
      if (btn) {
        btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Adding...</span>';
        btn.disabled = true;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
        });

        if (res.ok) {
          if (btn) btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!</span>';
          await renderDrawer();
          openCartDrawer();
        } else {
          const err = await res.json();
          if (btn) btn.innerHTML = err.description || 'Error';
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        if (btn) btn.innerHTML = 'Error — try again';
      } finally {
        setTimeout(() => {
          if (btn) { btn.innerHTML = originalHTML; btn.disabled = false; }
        }, 2000);
      }
    });
  });

  /* =============================================
     SCROLL REVEAL
  ============================================= */
  const revealEls = document.querySelectorAll('.animate-in, .reveal, .fade-in-up');
  if ('IntersectionObserver' in window && revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => revealObserver.observe(el));
  }

  /* =============================================
     PRODUCT GALLERY THUMBNAILS
  ============================================= */
  const thumbBtns = document.querySelectorAll('.product-gallery-thumb');
  const mainImage = document.getElementById('main-product-image');

  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (mainImage) {
        const newSrc = btn.dataset.src;
        const newSrcset = btn.dataset.srcset;
        if (newSrc) mainImage.src = newSrc;
        if (newSrcset) mainImage.srcset = newSrcset;
      }
    });
  });

  /* =============================================
     QUANTITY SELECTOR (product page)
  ============================================= */
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const btns = selector.querySelectorAll('button');
    if (btns[0]) btns[0].addEventListener('click', () => {
      const val = parseInt(input?.value || '1');
      if (val > 1 && input) input.value = val - 1;
    });
    if (btns[1]) btns[1].addEventListener('click', () => {
      const val = parseInt(input?.value || '1');
      if (input) input.value = val + 1;
    });
  });

  /* =============================================
     VARIANT SELECTOR (product page)
  ============================================= */
  document.querySelectorAll('.variant-option').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.parentElement;
      group?.querySelectorAll('.variant-option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const form = btn.closest('form');
      const variantInput = form?.querySelector('[name="id"]');
      const variantId = btn.dataset.variantId;
      if (variantInput && variantId) variantInput.value = variantId;

      const price = btn.dataset.price;
      if (price) {
        const priceEl = document.querySelector('.product-price');
        if (priceEl) priceEl.textContent = formatMoney(parseInt(price));
      }
    });
  });

  /* =============================================
     PRODUCT PAGE ACCORDION
  ============================================= */
  document.querySelectorAll('.product-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.product-accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.product-accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* =============================================
     COLLECTION FILTER + SORT
  ============================================= */
  const filterToggle = document.querySelector('.collection-filter-toggle');
  const filterDrawer = document.querySelector('.collection-filter-drawer');
  const filterClose = document.querySelector('.filter-close-btn');

  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener('click', () => {
      filterDrawer.classList.toggle('open');
      filterToggle.classList.toggle('active');
    });
    if (filterClose) filterClose.addEventListener('click', () => {
      filterDrawer.classList.remove('open');
      filterToggle.classList.remove('active');
    });
  }

  // Filter chips
  document.querySelectorAll('.filter-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      const group = chip.closest('.filter-group');
      group?.querySelectorAll('.filter-chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      applyFilters();
    });
  });

  // Sort select
  const sortSelect = document.querySelector('.collection-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Grid toggle
  document.querySelectorAll('.grid-toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.grid-toggle-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const grid = document.querySelector('.product-grid');
      if (grid) {
        const cols = btn.dataset.cols;
        grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
      }
    });
  });

  // Clear filters
  const clearFilters = document.querySelector('.clear-filters-btn');
  if (clearFilters) {
    clearFilters.addEventListener('click', () => {
      document.querySelectorAll('.filter-chip').forEach(chip => {
        chip.classList.toggle('active', chip.dataset.value === 'all');
      });
      applyFilters();
    });
  }

  function applyFilters() {
    const activeType = document.querySelector('.filter-group[data-filter="type"] .filter-chip.active')?.dataset.value;
    const activePrice = document.querySelector('.filter-group[data-filter="price"] .filter-chip.active')?.dataset.value;
    const activeAvail = document.querySelector('.filter-group[data-filter="availability"] .filter-chip.active')?.dataset.value;

    document.querySelectorAll('.product-card-wrapper').forEach(card => {
      let show = true;
      const type = card.dataset.type?.toLowerCase() || '';
      const price = parseInt(card.dataset.price || '0');
      const avail = card.dataset.available;

      if (activeType && activeType !== 'all' && type !== activeType.toLowerCase()) show = false;
      if (activePrice && activePrice !== 'all') {
        if (activePrice === 'under25' && price >= 2500) show = false;
        if (activePrice === '25to50' && (price < 2500 || price >= 5000)) show = false;
        if (activePrice === '50to100' && (price < 5000 || price >= 10000)) show = false;
        if (activePrice === 'over100' && price < 10000) show = false;
      }
      if (activeAvail && activeAvail === 'instock' && avail !== 'true') show = false;

      card.style.display = show ? '' : 'none';
    });

    // Update count
    const visible = document.querySelectorAll('.product-card-wrapper:not([style*="none"])').length;
    const countEl = document.querySelector('.collection-product-count');
    if (countEl) countEl.textContent = visible + ' products';
  }

  /* =============================================
     CART PAGE — QUANTITY CONTROLS
  ============================================= */
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    const dec = selector.querySelector('[data-decrease]');
    const inc = selector.querySelector('[data-increase]');
    if (dec) dec.addEventListener('click', () => {
      const v = parseInt(input?.value || '1');
      if (v > 0 && input) input.value = v - 1;
    });
    if (inc) inc.addEventListener('click', () => {
      const v = parseInt(input?.value || '1');
      if (input) input.value = v + 1;
    });
  });

  /* =============================================
     INIT
  ============================================= */
  renderDrawer();

});

/* =============================================
   POLICY PAGE CONTENT INJECTION
   Injects policy content client-side to bypass
   Shopify's server-side page cache
============================================= */
(function() {
  var policyContent = {
    'shipping-policy': '<p>Every Pink MahogHany order is packed with care and intention. Here is everything you need to know about how we get your fragrance to you.</p><h2>Processing Time</h2><p>Orders are processed within 7 business days (Monday through Friday, excluding holidays). You will receive a shipping confirmation email with tracking information once your order ships.</p><h2>Domestic Shipping (United States)</h2><p>Available shipping options, delivery timing, and any applicable shipping charges are displayed at checkout. Delivery timing begins after the processing period.</p><h2>Order Tracking</h2><p>Once your order ships, you will receive a confirmation email with a tracking number. You can track your package directly through the carrier\'s website or via your account dashboard.</p><h2>Address Accuracy</h2><p>Please double-check your shipping address before placing your order. Pink MahogHany is not responsible for packages lost or delayed due to an incorrect address entered at checkout. If you notice an error immediately after placing your order, contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a> and we will do our best to correct it before shipment.</p><h2>Lost or Damaged Packages</h2><p>If your package arrives damaged or is marked as delivered but cannot be located, please contact us within 7 days of the delivery date at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a>. Include your order number and photos of any damage. We will work with you to resolve the issue promptly.</p><h2>International Shipping</h2><p>We currently ship within the United States only. International shipping is coming soon \u2014 follow us on Instagram <a href="https://instagram.com/pink_mahoghany" target="_blank" rel="noopener">@pink_mahoghany</a> for updates.</p><h2>Questions?</h2><p>Contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a> and we will be happy to help.</p>',

    'returns': '<p>Your satisfaction is our priority. If something is not right with your order, we want to make it right.</p><h2>Return Eligibility</h2><p>We accept returns on unused, unopened items in their original packaging within <strong>30 days</strong> of the delivery date. Due to the nature of fragrance products, we are unable to accept returns on opened or used items unless the product arrived damaged or defective.</p><h2>How to Start a Return</h2><p>Email us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a> with your order number and reason for return. We will respond within 1\u20132 business days with return instructions and a return authorization number.</p><h2>Refunds</h2><p>Once your return is received and inspected, we will notify you by email. Approved refunds are processed to your original payment method within <strong>5\u20137 business days</strong>. Please note that original shipping charges are non-refundable.</p><h2>Exchanges</h2><p>We are happy to exchange an unopened product for a different scent or size. Contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a> to arrange an exchange. Exchange shipping costs are the responsibility of the customer.</p><h2>Damaged or Defective Items</h2><p>If your order arrives damaged or you received the wrong item, please contact us within <strong>7 days</strong> of delivery with photos of the damage. We will send a replacement or issue a full refund at no cost to you.</p><h2>Sale Items</h2><p>All sale and discounted items are final sale and are not eligible for return or exchange.</p><h2>Questions?</h2><p>Reach us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a> \u2014 we are always happy to help.</p>',

    'privacy-policy': '<p>Pink MahogHany (\u201cwe,\u201d \u201cour,\u201d or \u201cus\u201d) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or make a purchase.</p><h2>Information We Collect</h2><p>We collect information you provide directly to us, including your name, email address, shipping address, phone number, and payment information when you place an order or create an account. We also automatically collect certain information about your device and browsing behavior through cookies and similar technologies.</p><h2>How We Use Your Information</h2><p>We use the information we collect to process and fulfill your orders, communicate with you about your orders and account, send marketing communications (with your consent), improve our website and products, and comply with legal obligations.</p><h2>Sharing Your Information</h2><p>We do not sell your personal information. We share your information only with trusted service providers who assist us in operating our website and fulfilling orders (such as shipping carriers and payment processors), and as required by law.</p><h2>Cookies</h2><p>We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser preferences.</p><h2>Data Security</h2><p>We implement industry-standard security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p><h2>Your Rights</h2><p>You have the right to access, correct, or delete your personal information. To exercise these rights, contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a>.</p><h2>Contact Us</h2><p>If you have questions about this Privacy Policy, contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a>.</p>',

    'terms-of-service': '<p>Welcome to Pink MahogHany. By accessing our website or purchasing our products, you agree to these Terms of Service. Please read them carefully.</p><h2>Products &amp; Pricing</h2><p>All prices are listed in U.S. dollars and are subject to change without notice. We reserve the right to modify or discontinue any product at any time. In the event of a pricing error, we reserve the right to cancel the affected order and notify you promptly.</p><h2>Orders</h2><p>Placing an order constitutes an offer to purchase. We reserve the right to refuse or cancel any order for any reason, including product unavailability, errors in pricing or product information, or suspected fraudulent activity.</p><h2>Payment</h2><p>We accept all major credit cards and other payment methods displayed at checkout. Payment is processed securely through our payment provider. By submitting your payment information, you authorize us to charge the total order amount.</p><h2>Intellectual Property</h2><p>All content on this website \u2014 including text, images, logos, product names, and fragrance compositions \u2014 is the exclusive property of Pink MahogHany and may not be reproduced, distributed, or used without our express written permission.</p><h2>Fragrance Sensitivity</h2><p>Our products contain natural and synthetic fragrance compounds. If you have known sensitivities or allergies, please review the ingredient information on each product page before purchasing. Pink MahogHany is not responsible for adverse reactions resulting from individual fragrance sensitivities.</p><h2>Limitation of Liability</h2><p>Pink MahogHany shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website or our products. Our total liability shall not exceed the amount paid for the product in question.</p><h2>Governing Law</h2><p>These Terms of Service are governed by the laws of the State of Texas. Any disputes shall be resolved in the courts of Gregg County, Texas.</p><h2>Contact Us</h2><p>Questions about these terms? Contact us at <a href="mailto:info@pinkmahoghany.com">info@pinkmahoghany.com</a>.</p>'
  };

  var pathParts = window.location.pathname.split('/');
  var pageHandle = pathParts[pathParts.length - 1];

  if (policyContent[pageHandle]) {
    var injectContent = function() {
      var body = document.getElementById('policy-content-body') || document.querySelector('.static-page-body.rte');
      if (body && (pageHandle === 'shipping-policy' || !body.textContent.trim())) {
        body.innerHTML = policyContent[pageHandle];
      }
      var label = document.querySelector('.static-page-hero .section-label span');
      if (label) label.textContent = 'Customer Care';
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectContent);
    } else {
      injectContent();
    }
  }
})();
